export default "__VITE_ASSET__DyDVdFXT__"